import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { TravelApprovalListView } from '../feature-sets/TravelApprovalListView'

export const TravelApprovalsPage = () => {
  const intl = useProcurifyIntl()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.travelApprovalsPageTitle)}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.travelApprovalsPageTitle),
        },
      ]}
    >
      <TravelApprovalListView />
    </Page>
  )
}
